import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Button, List, ListItemButton, Typography } from "@mui/material";
import React, { FC } from "react";

import { formatClock } from "../helpUtils";
import { HelpChapter } from "../types";

interface TimelineToggleProps {
  count: number;
  open: boolean;
  /** Receives the click so the caller can anchor a popover to the button. */
  onClick: React.MouseEventHandler<HTMLElement>;
}

/** "Timeline (N) ⌄": opens a video's timeline entries upward. */
export const TimelineToggle: FC<TimelineToggleProps> = ({ count, open, onClick }) => (
  <Button
    size="small"
    variant="outlined"
    aria-expanded={open}
    onClick={onClick}
    endIcon={<ExpandMoreIcon sx={{ transform: open ? "none" : "rotate(180deg)", transition: "transform .15s" }} />}
    sx={{ minWidth: 0 }}
  >
    Timeline ({count})
  </Button>
);

interface TimelineListProps {
  chapters: HelpChapter[];
  /** The entry playing now, if known. */
  current?: HelpChapter;
  onSelect: (chapter: HelpChapter) => void;
}

export const TimelineList: FC<TimelineListProps> = ({ chapters, current, onSelect }) => (
  <List dense disablePadding>
    {chapters.map((chapter) => (
      <ListItemButton
        key={chapter.start}
        selected={chapter === current}
        onClick={() => onSelect(chapter)}
        sx={{ gap: 1.25, borderRadius: 1 }}
      >
        <Box component="span" sx={{ width: 36, flex: "none" }}>
          <Typography variant="caption" color="text.secondary">
            {formatClock(chapter.start)}
          </Typography>
        </Box>
        <Typography variant="body2">{chapter.title}</Typography>
      </ListItemButton>
    ))}
  </List>
);
